'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      class: ['checkbox', {
        'checkbox-disabled': _vm.disabled,
        'checkbox-large': _vm.large
      }],
      on: {
        "click": function click($event) {
          !_vm.disabled && _vm.$emit('input', _vm.isRadio ? _vm.index : !_vm.value);
        }
      }
    }, [_vm.label ? _c('label', {
      domProps: {
        "innerHTML": _vm._s(_vm.label)
      }
    }) : _vm._e(), _vm._v(" "), _c('input', {
      attrs: {
        "name": _vm.name,
        "type": _vm.type || 'checkbox'
      },
      domProps: {
        "checked": _vm.isChecked
      }
    }), _vm._v(" "), _c('i', {
      class: ['checkbox-icon', _vm.iconClass]
    })]);
  },
  staticRenderFns: [],
  name: 'checkbox',
  props: {
    name: String,
    type: String,
    index: Number,
    value: [Boolean, Number],
    label: String,
    round: Boolean,
    disabled: Boolean,
    large: Boolean
  },
  computed: {
    isRadio: function isRadio() {
      return this.type === 'radio';
    },
    isChecked: function isChecked() {
      return this.isRadio ? this.value === this.index : this.value;
    },
    iconClass: function iconClass() {
      if (this.isRadio || this.round) {
        // 当type为radio，或round属性为true时展示圆形框
        if (this.isChecked) {
          return 'icon-success-fill';
        } else {
          return this.large ? 'icon-circle' : 'icon-circle-bold';
        }
      } else {
        return this.isChecked ? 'icon-checkbox' : 'icon-checkbox-border';
      }
    }
  }
});

exports.default = index;
